(function() {
  // --- Helpers ---

  function parseZip() {
    var el = document.getElementById('popup-zip');
    if (!el) return null;
    var t = (el.textContent || el.innerText || '').trim();
    var zip = parseInt(t, 10);
    return isNaN(zip) ? null : zip;
  }

  function isCA(zip) {
    // CA ZIPs are roughly 90001–96199
    return zip >= 90000 && zip <= 96199;
  }

  function isTX(zip) {
    // TX ZIPs: 733xx, 750xx–799xx, 885xx (approx range)
    return (zip >= 73300 && zip <= 73399) ||
           (zip >= 75000 && zip <= 79999) ||
           (zip >= 88500 && zip <= 88599);
  }

  function isCAorTX(zip) {
    return isCA(zip) || isTX(zip);
  }

  // Get cart total in cents from checkout button or FreeShippingBar
  function getCartTotalCents() {
    var btn = document.querySelector('.js-checkout-button');
    if (btn && btn.hasAttribute('data-cart-total')) {
      var val = parseInt(btn.getAttribute('data-cart-total'), 10);
      if (!isNaN(val)) return val;
    }

    var bar = document.querySelector('.FreeShippingBar[data-cart-total]');
    if (bar) {
      var v2 = parseInt(bar.getAttribute('data-cart-total'), 10);
      if (!isNaN(v2)) return v2;
    }

    return null;
  }

  function cartHasOnlyAccessories() {
    var items = document.querySelectorAll('[data-cart-item]');
    if (!items.length) return false;

    for (var i = 0; i < items.length; i++) {
      var sku = items[i].getAttribute('data-sku') || '';
      if (!sku.toLowerCase().includes('accessories')) {
        return false;
      }
    }
    return true;
  }

  // Universal money formatter (USD)
  function formatMoney(cents) {
    if (typeof cents === 'string') cents = parseInt(cents, 10);
    if (isNaN(cents)) cents = 0;

    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(cents / 100);
  }

  // --- 16FOOTOVER warning logic ---

  function update16FootOverWarning() {
    var warningEl = document.querySelector('.Cart__Warning--16FOOTOVER[data-has-16footover="true"]');
    if (!warningEl) return;

    var zip = parseZip();
    var showWarning = true;

    if (zip !== null) {
      if (isCAorTX(zip)) {
        showWarning = false;
      }
    }

    warningEl.style.display = showWarning ? 'block' : 'none';
  }
  window.update16FootOverWarning = update16FootOverWarning;

  // --- Freight bar logic ---
  //
  // $299 flat-rate freight unlocks at:
  //   * $749   in California & Texas
  //   * $1,500 in all other states
  // Liquid renders a region-agnostic message. Once a ZIP is known from the
  // ZIP popup (#popup-zip) we rewrite the message and progress bar for that
  // region. Progress is measured against data-qualifying-total, which
  // excludes samples and accessories.

  function updateFreightPriceForRegion() {
    var bar = document.querySelector('.FreeShippingBar');
    if (!bar) return;
    if (bar.getAttribute('data-accessories-only') === 'true') return;
    if (bar.getAttribute('data-samples-only') === 'true') return;

    var zip = parseZip();
    if (zip === null) return; // keep the region-agnostic Liquid message

    var qualifying = parseInt(bar.getAttribute('data-qualifying-total'), 10);
    if (isNaN(qualifying)) return;

    var thresholdCATX = parseInt(bar.getAttribute('data-threshold-catx'), 10) || 74900;
    var thresholdOther = parseInt(bar.getAttribute('data-threshold-other'), 10) || 150000;
    var threshold = isCAorTX(zip) ? thresholdCATX : thresholdOther;

    var msg = bar.querySelector('.js-freight-message');
    var fill = bar.querySelector('.js-freight-fill');

    if (msg) {
      if (qualifying >= threshold) {
        msg.innerHTML = 'You’ve unlocked <strong>flat-rate freight shipping</strong> for <strong>$299</strong> at checkout!';
      } else {
        var remaining = threshold - qualifying;
        msg.innerHTML = 'Spend <strong>' + formatMoney(remaining) + '</strong> more to unlock <strong>flat-rate freight shipping</strong> for <strong>$299</strong>' +
          (isCAorTX(zip) ? '' : ' <span class="Text--subdued">(orders of ' + formatMoney(threshold) + '+ outside CA &amp; TX)</span>') + '.';
      }
    }

    if (fill) {
      var pct = Math.max(0, Math.min(100, Math.round((qualifying * 100) / threshold)));
      fill.style.width = pct + '%';
    }
  }
  window.updateFreightPriceForRegion = updateFreightPriceForRegion;

  // --- Checkout button total logic ---

  function updateCheckoutButtonTotal() {
    var btn = document.querySelector('.js-checkout-button');
    if (!btn) return;

    var totalCents = parseInt(btn.getAttribute('data-cart-total'), 10);
    if (isNaN(totalCents)) return;

    var totalSpan = document.querySelector('.js-checkout-total');
    if (!totalSpan) return;

    // Always show the true cart subtotal. Freight is applied at checkout by
    // the shipping apps after the address step.
    totalSpan.textContent = formatMoney(totalCents);
  }

  window.updateCheckoutButtonTotal = updateCheckoutButtonTotal;

  // --- Initial run on page load ---

  document.addEventListener('DOMContentLoaded', function() {
    update16FootOverWarning();
    updateFreightPriceForRegion();
    updateCheckoutButtonTotal();
  });

  document.addEventListener('cart:refresh', function() {
    update16FootOverWarning();
    updateFreightPriceForRegion();
    updateCheckoutButtonTotal();
  });

})();
